export default __webpack_public_path__ + "static/media/Fortnite-Cake.840c964b.jpg";